module.exports = __webpack_public_path__ + "img/anon.8cff2b8.png";